document.addEventListener(
  'keydown',
  function () {
    document.documentElement.classList.add('using-keyboard');
  },
  true
);
document.addEventListener(
  'mousedown',
  function () {
    document.documentElement.classList.remove('using-keyboard');
  },
  true
);
document.addEventListener(
  'touchstart',
  function () {
    document.documentElement.classList.remove('using-keyboard');
  },
  true
);
